import React from "react";

function fmtTime(iso) {
  try {
    return new Date(iso).toLocaleString("en-AU", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

function DocketBody({ order, copyLabel }) {
  const total = order.items.reduce((s, i) => s + i.price * i.quantity, 0);
  const isBar = order.order_type === "bar";
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <div style={{ fontWeight: 700, fontSize: "16pt", letterSpacing: "1.5px" }}>GLEDSWOOD</div>
        <div style={{ fontSize: "9pt", letterSpacing: "2px" }}>HOMESTEAD &amp; WINERY</div>
        <div style={{ fontSize: "16pt", marginTop: "6px", fontWeight: 700, letterSpacing: "1px" }}>
          {isBar ? "BAR ORDER" : "KITCHEN DOCKET"}
        </div>
        <div style={{ fontSize: "8pt", marginTop: "3px" }}>{copyLabel}</div>
      </div>

      <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />

      <div style={{ fontSize: "16pt", fontWeight: 700, display: "flex", justifyContent: "space-between" }}>
        <span>TABLE {order.table_number}</span>
        <span>#{order.order_number}</span>
      </div>
      <div style={{ fontSize: "11pt" }}>{order.customer_name}</div>
      <div style={{ fontSize: "9pt" }}>{fmtTime(order.created_at)}</div>
      {order.dietary ? (
        <div style={{ fontSize: "12pt", fontWeight: 700, marginTop: "6px" }}>
          DIETARY: {order.dietary}
        </div>
      ) : null}

      <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />

      <table style={{ width: "100%", fontSize: "13pt", borderCollapse: "collapse" }}>
        <tbody>
          {order.items.map((it, idx) => (
            <tr key={`${it.menu_item_id}-${idx}`}>
              <td style={{ verticalAlign: "top", fontWeight: 700, width: "36px", paddingBottom: "4px" }}>
                {it.quantity}x
              </td>
              <td style={{ verticalAlign: "top", paddingBottom: "4px" }}>
                {it.name}
                {it.notes ? (
                  <div style={{ fontSize: "10pt", fontStyle: "italic" }}>&#8627; {it.notes}</div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {order.notes ? (
        <>
          <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />
          <div style={{ fontSize: "11pt", fontWeight: 700 }}>NOTES:</div>
          <div style={{ fontSize: "11pt" }}>{order.notes}</div>
        </>
      ) : null}

      <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />
      <div style={{ fontSize: "13pt", display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
        <span>TOTAL</span>
        <span>${total.toFixed(2)}</span>
      </div>
      <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />
      <div style={{ textAlign: "center", fontSize: "9pt", marginTop: "6px" }}>
        {isBar ? "*** BAR ***" : "*** DINE IN ***"}
      </div>
    </div>
  );
}

// Hidden docket, becomes visible only during window.print() (see index.css #print-docket).
// Prints TWO identical copies, each centered on its own A4 portrait page.
export default function PrintDocket({ order }) {
  if (!order) return <div id="print-docket" />;

  return (
    <div id="print-docket">
      <div className="docket-page">
        <div className="docket-inner">
          <DocketBody order={order} copyLabel="COPY 1 of 2" />
        </div>
      </div>
      <div className="docket-page">
        <div className="docket-inner">
          <DocketBody order={order} copyLabel="COPY 2 of 2" />
        </div>
      </div>
    </div>
  );
}
